import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface INotifyPatientFromAlertVariables {
    id: number;
    message: string;
}

export function useNotifyPatientFromAlert() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, INotifyPatientFromAlertVariables>({
        mutationKey: [QueryKeys.alerts, 'notifyPatient'],
        mutationFn: async ({ id, message }: INotifyPatientFromAlertVariables) => {
            return await AlertApi.notifyPatient(id, message);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertDetail, variables.id] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alerts] });
            notifications.show({
                title: t('notification.success'),
                message: t('alert.notifications.patientNotified'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
